"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
var AiUserQuestionaryField;
(function (AiUserQuestionaryField) {
    AiUserQuestionaryField["NAME"] = "name";
    AiUserQuestionaryField["BIRTHDAY"] = "birthday";
    AiUserQuestionaryField["AGE"] = "age";
    AiUserQuestionaryField["NATIONALITY"] = "nationality";
    AiUserQuestionaryField["APPEARANCE"] = "appearance";
    AiUserQuestionaryField["HEIGHT"] = "height";
    AiUserQuestionaryField["WEIGHT"] = "weight";
    AiUserQuestionaryField["EYE_COLOR"] = "eyeColor";
    AiUserQuestionaryField["SHOE_SIZE"] = "shoeSize";
    AiUserQuestionaryField["TRAITS_OF_CHARACTER"] = "traitsOfCharacter";
    AiUserQuestionaryField["HOBBY"] = "hobby";
    AiUserQuestionaryField["JOB"] = "job";
    AiUserQuestionaryField["WHY_LIKE_JOB"] = "whyLikeJob";
    AiUserQuestionaryField["PRIORITY_IN_LIFE"] = "priorityInLife";
    AiUserQuestionaryField["SPORT"] = "sport";
    AiUserQuestionaryField["ADDRESS"] = "address";
    AiUserQuestionaryField["NATIVE_LANGUAGE"] = "nativeLanguage";
    AiUserQuestionaryField["WEAR"] = "wear";
    AiUserQuestionaryField["SLEEP_IN"] = "sleepIn";
    AiUserQuestionaryField["COUNTRIES_VISITED"] = "countriesVisited";
    AiUserQuestionaryField["MOVIES"] = "movies";
    AiUserQuestionaryField["BOOKS"] = "books";
    AiUserQuestionaryField["MUSIC"] = "music";
    AiUserQuestionaryField["FOOD"] = "food";
    AiUserQuestionaryField["FAVORITE_COUNTRIES"] = "favoriteCountries";
    AiUserQuestionaryField["ALCOHOL"] = "alcohol";
    AiUserQuestionaryField["ENJOY_TALKING_ABOUT"] = "enjoyTalkingAbout";
    AiUserQuestionaryField["COMMUNICATION_STYLE"] = "communicationStyle";
    AiUserQuestionaryField["INSTAGRAM"] = "instagram";
    AiUserQuestionaryField["WEBSITE"] = "website";
})(AiUserQuestionaryField = exports.AiUserQuestionaryField || (exports.AiUserQuestionaryField = {}));
class AiUserQuestionaryProvider extends DataProvider_1.default {
    get fragments() {
        return {
            AiUserQuestionary: () => `
        ... on AiUserQuestionary {
          userId
          fields
        }
      `,
        };
    }
    search({ userId }) {
        return this.query("aiUserQuestionarySearch", { userId }, this.getFragment("AiUserQuestionary"));
    }
    update({ data }) {
        return this.mutate("aiUserQuestionaryUpdate", { data }, this.getFragment("AiUserQuestionary"));
    }
}
exports.AiUserQuestionaryProvider = AiUserQuestionaryProvider;
//# sourceMappingURL=AiUserQuestionaryProvider.js.map